import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import css from '../Companies/style.module.css';

export default function LoadingCompanies() {
    const placeholders = Array.from({ length: 6 });

    return (
        <section className={`${css.companySection}`}>
            {/* Header */}
            <div className={css.header}>
                <div className={css.headerContent}>
                    <Skeleton baseColor="var(--surface-sunken)" width={30} height={30} />

                    <div>
                        <h3 className={css.title}>
                            <Skeleton baseColor="var(--surface-sunken)" width={200} />
                        </h3>
                        <p className={css.subtitle}>
                            <Skeleton baseColor="var(--surface-sunken)" width={350} />
                        </p>
                    </div>
                </div>
            </div>

            {/* Search and Action Bar */}
            <div className={css.actionBar}>
                <div className={css.searchContainer}>
                    <Skeleton className={css.searchInput} baseColor="var(--surface-sunken)" />
                </div>
                <button className={`${css.addButton} rounded-5`} aria-hidden>
                    <Skeleton baseColor="var(--surface-sunken)" width={100} />
                </button>
            </div>

            {/* Company Cards */}
            <div className="container mt-3">
                <div className="row">
                    {placeholders.map((_, idx) => (
                        <div key={idx} className="col-md-4 mb-4">
                            <div className={`${css.card}`}>
                                {/* Status Badge */}
                                <div className={css.statusBadge}>
                                    <span className={`${css.statusText} ${css.statusInactive}`}>
                                        <Skeleton baseColor="var(--surface-sunken)" width={60} />
                                    </span>
                                </div>

                                {/* Company Logo */}
                                <div className={css.logoContainer}>
                                    {/* circle skeleton that fits into your .logo styles */}
                                    <Skeleton className={css.logo} circle={true} height={64} width={64} baseColor="var(--surface-sunken)" />
                                </div>

                                {/* Company Info */}
                                <div className={css.companyInfo}>
                                    <h4 className={css.companyName}>
                                        <Skeleton baseColor="var(--surface-sunken)" width={`80%`} />
                                    </h4>

                                    <div className={css.emailContainer}>
                                        <i className={`fas fa-envelope ${css.emailIcon}`}></i>
                                        <p className={css.email}>
                                            <Skeleton baseColor="var(--surface-sunken)" width={`60%`} />
                                        </p>
                                    </div>

                                    {/* Projects Badge */}
                                    <div className={css.projectsBadge}>
                                        <p className={css.projectsCount}>
                                            <Skeleton baseColor="var(--surface-sunken)" width={120} />
                                        </p>
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className={css.controllerButtons}>
                                    <button className={css.customCardButtonCompanies} aria-hidden>
                                        <i className="fas fa-edit"></i>
                                        <Skeleton baseColor="var(--surface-sunken)" width={40} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
